import { render } from "./SidebarNavItem.vue?vue&type=template&id=1e4f20a3&scoped=true"
import script from "./SidebarNavItem.vue?vue&type=script&lang=js"
export * from "./SidebarNavItem.vue?vue&type=script&lang=js"

import "./SidebarNavItem.vue?vue&type=style&index=0&id=1e4f20a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4f20a3"]])

export default __exports__